import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
  name: "VisitBasedSchedule",
  props: {
    visitId: {
      type: String,
      default: ""
    },
    visitName:{
        type: String,
        default: ""
    },
    subjectId: {
      type: String,
      default: ""
    }
  },
  components: {
    customModal
  },
    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: store.getters.getIdToken,
            head: {},
            payload: {
                studyId: "",
                patientId: "",
                visitDetails: [
                    {
                        visitId: this.visitId,
                        visitDate: ""
                    }
                ]
            },
            errors: [false],
        };
    },
    async mounted() {
        console.log("VisitBasedSchedule mounted with visitId:", this.visitId);
        this.head = {
            headers: {
                Authorization: "Bearer " + this.token,
                "Content-Type": "application/json",
            },
        };
        this.payload = {
            studyId: store.getters.getStudyIs,
            patientId: this.subjectId,
            visitDetails: [
                {
                    visitId: this.visitId,
                    visitDate: ""
                }
            ]
        }
    },
    methods: {
        async createVisitBasedSchedule() {
            await this.validate();
            if (!this.errors.includes(true)) {
                await axios.post(
                    `${this.baseurl}/management/patientschedule/createvisitbasedschedule`,
                    this.payload,
                    this.head
                )
                    .then((response) => {
                        this.$emit("closeModal");
                    })
                    .catch((error) => {
                        console.error("Error creating visit-based schedule:", error);
                    });
            }
        },
        async validate(){
            const visitDate = this.payload.visitDetails[0]?.visitDate;
            if(!visitDate || visitDate.trim() === ""){
                this.errors[0] = true;
            }            
            else{
                this.errors[0] = false;
            }

        }
    }
}